import { AfterViewInit, Component, Input, ViewChild, inject } from '@angular/core';

import {ComboBoxComponent} from '../inputs/combo-box/combo-box.component';
import {OmniSearchService} from './omni-search.service';
import {HotkeysService} from '../../services/hotkeys.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {LoggerService} from '../../services/logger.service';

@UntilDestroy()
@Component({
    selector: 'app-omni-search',
    imports: [ComboBoxComponent],
    templateUrl: './omni-search.component.html',
    styleUrls: ['./omni-search.component.scss']
})
export default class OmniSearchComponent implements AfterViewInit {
	service = inject(OmniSearchService);
	private hotkeysService = inject(HotkeysService);
	private logger = inject(LoggerService);


	// Compact mode allows search to condense into a round magnifying glass button used to display and hide the combobox
	@Input() compactMode = false;

	@ViewChild(ComboBoxComponent) comboBox?: ComboBoxComponent;

	ngAfterViewInit(): void {
		this.hotkeysService.search.pipe(untilDestroyed(this)).subscribe(event => {
			if (!this.comboBox) {
				this.logger.warn('OmniSearch could not locate the search input to focus!')
			} else {
				this.comboBox.focusInput();
			}
		});
	}

}
